import { createReducer } from '@reduxjs/toolkit'

import { companyLoggedIn, loggedOutClubOne, receivedClubOneDetails, receivedReservation } from '../../actions/actions'

const initialState = {
  status: 'anonymous',
  policy: true,
  profiling: true
}

const user = createReducer(initialState, {
  [receivedClubOneDetails]: (state, { payload: contactPerson }) => {
    state.status = 'logged-in'
    state.authSource = 'booking'
    setUserFieldsFromContactPerson(state, contactPerson)
  },
  [receivedReservation]: (state, { payload }) => {
    const { company, contactPerson } = payload
    const isClubOneUser = contactPerson.clubOneLevel !== 'NONE'
    const isBusinessUser = !!company?.name

    state.status = isClubOneUser ? 'logged-in' : 'anonymous'
    state.authSource = 'booking'
    state.business = isBusinessUser
    setUserFieldsFromContactPerson(state, contactPerson)
  },
  [companyLoggedIn]: state => {
    state.business = true
  },
  [loggedOutClubOne]: state => {
    state.status = 'logged-out'
  }
})

export default user

function setUserFieldsFromContactPerson(draftUser, contactPerson) {
  const { clientId, clubOneLevel, clubOneNumber, clubOnePoints } = contactPerson
  draftUser.id = clientId
  draftUser.number = clubOneNumber
  draftUser.points = clubOnePoints
  draftUser.level = clubOneLevel.toLowerCase()
}
